import React from 'react';
import AssignmentMultiSelect from './AssignmentMultiSelect';

const UserSiteAssignmentSelect = ({
  availableSites,
  selectedSiteIds,
  onChange,
  isDisabled,
}) => (
  <AssignmentMultiSelect
    items={availableSites}
    selectedIds={selectedSiteIds}
    onChange={onChange}
    isDisabled={isDisabled}
    name="assigned_sites"
  />
);

export default UserSiteAssignmentSelect;
